// extracted by mini-css-extract-plugin
export default {"about":"About_about__ytGu7","udemyLink":"About_udemyLink__WL+UP"};